import { checkUserHasAdminRole, checkUserHasBdmRole, checkUserHasManagerRole } from "app/services/app.state.service"
import AllWorkingHoursView from "../master-working-hours/AllWorkingHoursView";

export const WorkingHoursRouterFactory = () => {

    // Working hours are global master data, not manager-scoped, so admins see the same
    // full list managers do. Mirrors ExportReportsRouterFactory.
    // A BDM is admitted too, and the view drops every edit affordance for them
    // (HRMS-116 point 6: working hours read-only). @since NEXT_VERSION
    if(checkUserHasManagerRole() || checkUserHasAdminRole() || checkUserHasBdmRole()) {
        return <AllWorkingHoursView />
    }

    else {
        window.location.href = "/login";
    } 
}